<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <edit-dependent>
        </edit-dependent> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import editDependent from './todo-edit-dependents'
export default {
    components: {
        editDependent
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-edit-dependents.vue